import { Box, Button, Text, TextButton } from '@wix/design-system'
import { DismissFilled } from '@wix/wix-ui-icons-common/lazy'
import React, { FC } from 'react'

import s from './ModalMessage.scss'

type Props = {
  title?: string
  subtitle?: string
  closeBtnText?: string
  mainBtnText?: string
  onClose: () => void
}

export const ModalMessage: FC<Props> = ({ onClose, title, subtitle, closeBtnText, mainBtnText }) => {
  return (
    <Box
      width="100%"
      position="absolute"
      top="0"
      bottom="0"
      left="0"
      right="0"
      verticalAlign="bottom"
      zIndex="1000"
      backgroundColor="#4D5963A6"
      overflowY="hidden"
    >
      <Box padding="12px" direction="vertical" gap="8px">
        <TextButton skin="light" onClick={onClose}>
          <Box verticalAlign="middle" gap="8px">
            <DismissFilled />
            <Text weight="bold" light>
              {closeBtnText}
            </Text>
          </Box>
        </TextButton>
        <Box padding="26px 24px 36px" background="#fff" direction="vertical" borderRadius="12px" align="center">
          <EmailIcon />
          <Box marginTop="24px" marginBottom="36px" gap="8px" direction="vertical" align="center">
            <Text weight="bold">{title}</Text>
            <Text className={s.modalMessage}>{subtitle}</Text>
          </Box>
          <Button onClick={onClose}>{mainBtnText}</Button>
        </Box>
      </Box>
    </Box>
  )
}

const EmailIcon: FC = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="96" height="96" viewBox="0 0 96 96" fill="none">
    <g clip-path="url(#clip0_636_3753)">
      <path d="M0.699951 16.26L1.82995 48.47L2.69995 73.23H40.8499V16.26H0.699951Z" fill="#C2E2FF" />
      <path
        d="M79.01 16.26L80.13 48.47L81 73.23H40.85V16.26H79.01ZM26.93 52C28.2536 52.0139 29.3458 53.0173 29.4873 54.3162L29.5 54.48C29.5389 55.1386 29.3026 55.7838 28.8476 56.2615C28.3926 56.7393 27.7597 57.0067 27.1 57H16.61C15.2572 57.0059 14.1364 55.9761 14.0105 54.6476L14 54.48C13.9751 53.8219 14.2228 53.1827 14.6846 52.7133C15.1465 52.2438 15.7816 51.9858 16.44 52H26.93Z"
        fill="white"
      />
      <path d="M79.3 23.52H0.99999L0.73999 16.26H79.05L79.3 23.52Z" fill="#116DFF" />
      <path
        d="M12.9717 19.193C13.3472 18.8109 13.9709 18.8149 14.3648 19.202C14.7587 19.5891 14.7737 20.2127 14.3982 20.5948C14.0227 20.9769 13.399 20.9728 13.0051 20.5857C12.6111 20.1986 12.5962 19.5751 12.9717 19.193ZM5.21964 19.1906C5.59513 18.8085 6.21885 18.8126 6.61277 19.1997C7.00669 19.5868 7.02163 20.2104 6.64614 20.5925C6.27065 20.9746 5.64692 20.9705 5.25301 20.5834C4.85909 20.1963 4.84415 19.5727 5.21964 19.1906ZM9.09917 19.1832C9.47465 18.8011 10.0984 18.8052 10.4923 19.1923C10.8862 19.5794 10.9012 20.203 10.5257 20.5851C10.1502 20.9672 9.52645 20.9631 9.13253 20.576C8.73862 20.1889 8.72368 19.5653 9.09917 19.1832Z"
        fill="white"
      />
      <path
        d="M61.92 49.55L70.6 40.87C75.1719 45.7001 75.0677 53.2921 70.3649 57.9949C65.6621 62.6978 58.0701 62.802 53.24 58.23L53.09 58.08L61.92 49.55Z"
        fill="#FFD527"
      />
      <path d="M88.0601 83.4104L62.8401 79.4203L70.0801 38.1104L95.3001 42.1003L88.0601 83.4104Z" fill="#116DFF" />
      <path d="M87.1799 79.5003L65.1299 76.0103L71.0599 42.0303L93.0999 45.5203L87.1799 79.5003Z" fill="#C2E2FF" />
      <path
        d="M74 70.1803L79.82 71.1103C80.3226 71.1885 80.7725 71.4659 81.0679 71.8799C81.3306 72.248 81.4515 72.6962 81.4123 73.143L81.39 73.3103C81.1837 74.333 80.2258 75.0252 79.19 74.9003L73.37 74.0003C72.8687 73.9195 72.4206 73.6415 72.1256 73.2281C71.8634 72.8607 71.7417 72.4136 71.7787 71.9674L71.8 71.8003C71.9928 70.7655 72.9547 70.0572 74 70.1803ZM71.06 42.0303L93.1 45.5203L90.09 62.5103L68.05 59.0203L71.06 42.0303Z"
        fill="white"
      />
      <path d="M80.7147 41.2155L80.5581 42.2031L83.8174 42.7199L83.974 41.7323L80.7147 41.2155Z" fill="white" />
      <path
        d="M80.5599 52.1797L84.6999 49.1797C86.2354 51.469 85.6828 54.5631 83.4497 56.1793C81.2166 57.7956 78.1048 57.3537 76.4099 55.1797C76.413 55.1531 76.413 55.1263 76.4099 55.0997L80.5599 52.1797Z"
        fill="#FFD527"
      />
      <path
        d="M78.81 47.26C80.0195 47.26 81 48.2405 81 49.45C81 50.6595 80.0195 51.64 78.81 51.64C77.6005 51.64 76.62 50.6595 76.62 49.45C76.62 48.2405 77.6005 47.26 78.81 47.26ZM56.76 38.51C59.654 38.51 62 40.856 62 43.75C62 46.644 59.654 48.99 56.76 48.99C53.866 48.99 51.52 46.644 51.52 43.75C51.52 40.856 53.866 38.51 56.76 38.51Z"
        fill="#FCA760"
      />
      <path d="M82.8952 64.6905L73.7196 63.2372L73.5632 64.2249L82.7388 65.6782L82.8952 64.6905Z" fill="#192C55" />
      <path d="M32 45V44H11V45H32Z" fill="#192C55" />
      <path d="M29 41V40H14V41H29Z" fill="#192C55" />
      <path d="M70.7266 66.7231L70.883 65.7355L84.8094 67.9412L84.653 68.9289L70.7266 66.7231Z" fill="#192C55" />
    </g>
    <defs>
      <clipPath id="clip0_636_3753">
        <rect width="96" height="96" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
